import { CalendarDays, Loader2, Plus } from 'lucide-react';
import SelectField from '../../../../components/Forms/Input/SelectField';
import { IBranchDropdown } from '../../../../types/branches/branchInterfaces';

interface Props {
  branches: IBranchDropdown[];
  branchId: number | '';
  loading: boolean;
  branchError?: string;
  canPickBranch: boolean;
  creationDisabled: boolean;
  onBranchChange: (id: number) => void;
  onCreate: () => void;
}

const ReservationHeader = ({
  branches,
  branchId,
  loading,
  branchError,
  canPickBranch,
  creationDisabled,
  onBranchChange,
  onCreate,
}: Props) => (
  <header className="border-b border-stroke p-5 dark:border-strokedark sm:px-7">
    <div className="flex flex-col gap-5 xl:flex-row xl:items-end xl:justify-between">
      <div className="flex gap-3">
        <span className="h-fit rounded-xl border border-primary/15 bg-primary/10 p-2.5 text-primary">
          <CalendarDays className="h-5 w-5" />
        </span>
        <div>
          <h1 className="text-xl font-semibold text-black dark:text-white">
            Reservaciones
          </h1>
          <p className="mt-1 text-sm text-bodydark2">
            Organice la agenda, confirme llegadas y abra órdenes desde una sola
            vista.
          </p>
        </div>
      </div>
      <div className="flex w-full flex-col gap-3 sm:flex-row sm:items-end xl:max-w-2xl">
        {canPickBranch && (
          <div className="flex-1">
            {loading ? (
              <div className="flex h-[74px] items-center justify-center">
                <Loader2 className="h-5 w-5 animate-spin text-primary" />
              </div>
            ) : (
              <SelectField
                label="Sucursal"
                name="reservationBranch"
                value={branchId}
                iconKey="building"
                options={branches.map((b) => ({ value: b.id, label: b.name }))}
                onChange={(e) => onBranchChange(Number(e.target.value))}
              />
            )}
          </div>
        )}
        <button
          type="button"
          onClick={onCreate}
          disabled={!branchId || creationDisabled}
          className="mb-5 inline-flex h-[50px] items-center justify-center gap-2 rounded-xl bg-primary px-5 text-sm font-semibold text-white shadow-card disabled:cursor-not-allowed disabled:opacity-45"
        >
          <Plus className="h-4 w-4" />
          Nueva reservación
        </button>
      </div>
    </div>
    {branchError && (
      <p className="mt-3 text-sm font-medium text-danger">{branchError}</p>
    )}
  </header>
);

export default ReservationHeader;
